// escapeApi.js � Escape to Inner Peace backend integration (Phase 5).
// One function per Backend/routes/routes.js `escape*` endpoint, following
// the existing src/functions/*.js convention (fetch + Bearer token +
// JSON body, throw on !resp.ok) rather than scattering raw fetch calls
// across activity components.

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

async function post(path, token, body, { keepalive = false } = {}) {
  const resp = await fetch(`${BASE_URL}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
    keepalive,
  });

  let data = null;
  try {
    data = await resp.json();
  } catch {
    data = null;
  }

  if (!resp.ok) {
    const message = (data && data.message) || `Request to ${path} failed (${resp.status})`;
    const error = new Error(message);
    error.status = resp.status;
    error.body = data;
    throw error;
  }

  return data;
}

export function bootstrapEscapeSession({ token, userId }) {
  return post('/escapeBootstrap', token, { userId });
}

export function startEscapeGame({ token, userId, inviteId, employeeId, reportToken, gameId, name, role, round }) {
  return post('/escapeGameStart', token, { userId, inviteId, employeeId, reportToken, gameId, name, role, round });
}

export function saveEscapeProgress(
  { token, userId, gameRunId, activityId, activityScore, elapsedSeconds, gameId, name, role, employeeId, reportToken, reportId, round },
  options
) {
  return post(
    '/escapeGameProgress',
    token,
    { userId, gameRunId, activityId, activityScore, elapsedSeconds, gameId, name, role, employeeId, reportToken, reportId, round },
    options
  );
}

export function fetchEscapeState({ token, userId }) {
  return post('/escapeGameState', token, { userId });
}

export function completeEscapeGame({ token, userId, gameRunId, elapsedSeconds, gameId, name, role, employeeId, reportToken, reportId, round }) {
  return post('/escapeGameComplete', token, { userId, gameRunId, elapsedSeconds, gameId, name, role, employeeId, reportToken, reportId, round });
}

export function fetchEscapeResult({ token, userId }) {
  return post('/escapeGameResult', token, { userId });
}

export function fetchEscapeReplayStatus({ token, userId }) {
  return post('/escapeReplayStatus', token, { userId });
}

